import './App.css';
import { Routes, Route } from 'react-router-dom'
import Home from './pages/Home';
import Navbar from './components/Navbar';

function App() {
  return (
    <div className="App">
         <Navbar />
         
      <Routes>
        <Route>
            <Route path="/" element={<Home />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
